import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { DraftChanges, RepoDraft, RepoVersion } from "@/types";

// #278: Lese-Seite des Repo-Lifecycle. Konsumiert den API-Vertrag aus #275 wörtlich —
// weicht etwas ab, wird HIER nachgezogen, nicht im Backend improvisiert.

export function useRepoDrafts(repoId: string | undefined): UseQueryResult<RepoDraft[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "git-content", "drafts", repoId ?? "_none"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<RepoDraft[]>(`/git-content/repos/${repoId}/drafts`);
    },
    enabled: !!session && !!repoId,
  });
}

// Änderungs-Vorschau + Schema-Prüfung in einem. Funktioniert VOR und NACH dem Einreichen —
// der Aufrufer merkt den Unterschied nicht.
export function useDraftChanges(repoId: string | undefined, branch: string | null): UseQueryResult<DraftChanges> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "git-content", "changes", repoId ?? "_none", branch ?? "_none"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<DraftChanges>(
        `/git-content/repos/${repoId}/drafts/${encodeURIComponent(branch ?? "")}/changes`,
      );
    },
    enabled: !!session && !!repoId && !!branch,
  });
}

export function useRepoVersions(repoId: string | undefined): UseQueryResult<RepoVersion[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "git-content", "versions", repoId ?? "_none"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<RepoVersion[]>(`/git-content/repos/${repoId}/versions`);
    },
    enabled: !!session && !!repoId,
  });
}
